export var TelephoneType;
(function (TelephoneType) {
    TelephoneType[TelephoneType["Mobile"] = 1] = "Mobile";
    TelephoneType[TelephoneType["Landline"] = 2] = "Landline";
})(TelephoneType || (TelephoneType = {}));
